import type { SocialPlatform, SocialEmbed } from "@/types/social";

export function buildEmbedUrl(
    platform: SocialPlatform,
    ref: string,
    autoplay = true
): string {
    const enc = encodeURIComponent;

    switch (platform) {
        case "facebook":
            return `https://www.facebook.com/plugins/post.php?href=${enc(
                ref
            )}&show_text=true&width=500&lazy=true`;

        case "facebookPage":
            return `https://www.facebook.com/plugins/page.php?href=${enc(
                ref
            )}&tabs=timeline&width=500&height=600&small_header=false&adapt_container_width=true&hide_cover=false&show_facepile=true`;

        case "x":
            return `https://platform.twitter.com/embed/Tweet.html?id=${ref}&theme=light&dnt=true`;

        case "xTimeline":
            return `https://syndication.twitter.com/srv/timeline-profile/screen-name/${ref}?theme=light&dnt=true&chrome=noheader%20nofooter%20transparent`;

        case "linkedin":
            return `https://www.linkedin.com/embed/feed/update/urn:li:share:${ref}`;

        case "tiktok":
            return `https://www.tiktok.com/embed/v2/${ref}`;

        case "pinterest":
            return `https://assets.pinterest.com/ext/embed.html?id=${ref}`;
    }
}

/** Poster is always explicit now — no auto-derive for removed platforms. */
export function derivePoster(e: SocialEmbed): string | null {
    return e.poster ?? null;
}

export const PLATFORM_META: Record<
    SocialPlatform,
    { label: string; group: string; kind: "video" | "post" | "feed"; accent: string }
> = {
    facebook: { label: "Facebook", group: "facebook", kind: "post", accent: "#1877F2" },
    facebookPage: { label: "Facebook", group: "facebook", kind: "feed", accent: "#1877F2" },
    x: { label: "X", group: "x", kind: "post", accent: "#17160F" },
    xTimeline: { label: "X", group: "x", kind: "feed", accent: "#17160F" },
    linkedin: { label: "LinkedIn", group: "linkedin", kind: "post", accent: "#0A66C2" },
    tiktok: { label: "TikTok", group: "tiktok", kind: "video", accent: "#17160F" },
    pinterest: { label: "Pinterest", group: "pinterest", kind: "post", accent: "#E60023" },
};

export const EMBED_SANDBOX =
    "allow-scripts allow-same-origin allow-popups allow-popups-to-escape-sandbox allow-presentation allow-forms";

export const EMBED_ALLOW =
    "accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share; fullscreen";